import React, { Component } from 'react'

import PropTypes from 'prop-types'

import ReactDropZone from 'react-dropzone'

export default class DropZone extends Component {
  static propTypes = {
    onDrop: PropTypes.func.isRequired,
    maxSize: PropTypes.number.isRequired,
    accept: PropTypes.string.isRequired,
    multiple: PropTypes.bool.isRequired,
    wrapperClass: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object
  }

  static defaultProps = {
    maxSize: 2000000, // 2MB
    multiple: false,
    wrapperClass: '',
    className: ''
  }

  state = {
    errorMessage: null
  }

  render() {
    const { maxSize, accept, multiple, wrapperClass, className, style, onDrop, children } = this.props
    const { errorMessage } = this.state

    return (
      <div className={wrapperClass}>
        <ReactDropZone
          accept={accept}
          multiple={multiple}
          maxSize={maxSize}
          className={className}
          style={style}
          onDrop={(accepted, rejected) => onDrop(accepted, rejected)}
        >
          {!!children && children}
        </ReactDropZone>
        {errorMessage && <small className="text-danger">{errorMessage}</small>}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/components/UI/DropZone.js